import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const NativeIntegrationsPage = lazy(() => import('./pages/NativeIntegrationsPage'));
const WorkflowConnectorsPage = lazy(() => import('./pages/WorkflowConnectorsPage'));
const DataMappingPage = lazy(() => import('./pages/DataMappingPage'));
const BidirectionalSyncPage = lazy(() => import('./pages/BidirectionalSyncPage'));
const ConflictResolutionPage = lazy(() => import('./pages/ConflictResolutionPage'));

export const SyncRoutes: RouteObject = {
  path: 'sync',
  element: <ModuleGuard moduleId="data.sync" />,
  handle: { crumb: 'Data Sync & Integration' },
  children: [
    { index: true, element: <Navigate to="native-integrations" replace /> },
    { path: 'native-integrations', element: <NativeIntegrationsPage />, handle: { crumb: 'Native Integrations' } },
    { path: 'workflow-connectors', element: <WorkflowConnectorsPage />, handle: { crumb: 'Workflow Connectors' } },
    { path: 'data-mapping', element: <DataMappingPage />, handle: { crumb: 'Data Mapping' } },
    { path: 'bidirectional-sync', element: <BidirectionalSyncPage />, handle: { crumb: 'Bidirectional Sync' } },
    { path: 'conflict-resolution', element: <ConflictResolutionPage />, handle: { crumb: 'Conflict Resolution' } },
  ],
};
